import "core-js/modules/es.array.push.js";
export default {
  props: {
    detail: {
      type: Object,
      default: () => {}
    },
    partyCode: {
      type: String,
      default: ''
    },
    deviceDetailInfo: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      deviceType: 'pack',
      detailArray: {
        name: '',
        type: '',
        pid: '',
        version: ''
      },
      selectVideoInput: '',
      videoInputArray: [],
      selectAudioInput: '',
      audioInputChannel: {},
      deviceTypeTextMap: {
        pack: this.$t('detail.tvuOne'),
        receiver: this.$t('detail.tvuReceiver'),
        producer: this.$t('detail.tvuProducer'),
        channel: this.$t('detail.tvuChaneel'),
        cloudR: this.$t('detail.tvuCloudR')
      },
      voipTipsMap: {
        pack: 'packVoIPTip',
        receiver: 'receiverVoIPTip'
      },
      sourceListParams: {
        online: true,
        offline: true,
        living: true,
        condition: '',
        pageNum: 1,
        pageSize: 20
      },
      pgmNameInfo: {}
    };
  },
  watch: {
    'deviceDetailInfo.show': {
      handler(val) {
        var _info$version;
        if (!val) return;
        const {
          info
        } = this.detail;
        this.deviceType = this.returnSourceType(info);
        if (this.deviceType === 'channel') {
          this.getSourcelist();
        } else {
          this.sourceListParams.origin = undefined;
          this.detailArray.name = info.deviceName;
        }
        this.detailArray.type = this.deviceTypeTextMap[this.deviceType];
        this.detailArray.pid = info.devicePeerId ? this.returnPartyID(info.devicePeerId.toLocaleUpperCase()) : '';
        this.detailArray.version = (_info$version = info.version) === null || _info$version === void 0 ? void 0 : _info$version.slice(0, 3);
        this.getVideoInput(info);
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    getSourcelist() {
      this.sourceListParams.origin = 'channel';
      this.axios.post('/partyline-backend/receiver/v3/page', this.sourceListParams).then(res => {
        if (res.data.errorCode === '0x0') {
          const result = res.data.result.channel;
          result && result.forEach(item => {
            if (item.pid === this.detail.info.devicePeerId) {
              this.detailArray.name = item.channelName;
            }
          });
        }
      });
    },
    async getVideoInput(info) {
      this.videoInputArray = [];
      if (this.deviceType === 'pack') {
        this.getPackVideoInput();
      } else {
        // pp 单独处理要获取 productionId
        if (this.deviceType === 'producer') {
          await this.getProductionId(info);
        }
        this.getReceiverVideoInput(info);
        if (!(info.originMemberId.endsWith('voip') && info.deviceType == 'R')) {
          this.getEncoderInfo();
        }
      }
    },
    getPackVideoInput() {
      this.videoInputArray = this.videoInputArray.concat(['SDIIN', 'noVideo']);
      this.audioInputChannel.SDIIN = 1;
      this.audioInputChannel.noVideo = 1;
      const {
        info
      } = this.detail;
      const {
        originMemberId
      } = info;
      if (originMemberId.includes('voip')) {
        this.selectVideoInput = 'noVideo';
        this.selectAudioInput = 'voip';
      } else {
        this.selectVideoInput = 'SDIIN';
        this.selectAudioInput = 1;
      }
    },
    async getProductionId(info) {
      const params = {
        online: true,
        offline: false,
        living: false,
        condition: '',
        pageNum: 1,
        pageSize: 20
      };
      await this.axios.post('/partyline-backend/receiver/v3/page', params).then(res => {
        if (res.data.errorCode === '0x0') {
          const result = res.data.result.pps;
          result && result.forEach(item => {
            const list = item.pageInfo.list;
            list.forEach(rInfo => {
              if (rInfo.receiverId === info.devicePeerId) {
                info.id = rInfo.id;
                this.detailArray.name = rInfo.name;
              }
            });
          });
        }
      });
    },
    getReceiverVideoInput(info) {
      this.videoInputArray = [];
      this.audioInputChannel = {};
      const {
        devicePeerId,
        originMemberId
      } = info;
      const url = this.deviceType === 'receiver' || this.deviceType === 'channel' ? `/${devicePeerId}` : `/${devicePeerId}?productionId=${info.id}`;
      this.axios.get(`/partyline-backend/receiver/getEncoderSourcesV2${url}`).then(res => {
        if (res.data.errorCode === '0x0') {
          var _originMemberId$split;
          const result = res.data.result || [];
          const sourceType = originMemberId === null || originMemberId === void 0 ? void 0 : (_originMemberId$split = originMemberId.split('_')) === null || _originMemberId$split === void 0 ? void 0 : _originMemberId$split[1];
          result.forEach(item => {
            if (this.deviceType === 'receiver') {
              this.videoInputArray.push(item.name);
              this.audioInputChannel[item.name] = item.audioChannelCount / 2;
            } else if (this.deviceType === 'producer') {
              if (item.name == 'PGM') {
                this.pgmNameInfo.pgm = 'PGM';
                this.audioInputChannel[item.name] = item.audioChannelCount / 2;
                this.audioInputChannel['PGM (mix minus)'] = item.audioChannelCount / 2;
              } else if (item.name != 'PVW') {
                this.pgmNameInfo[item.name] = item.slotNo;
                this.videoInputArray.push(item.slotNo);
                this.audioInputChannel[item.slotNo] = item.audioChannelCount / 2;
              }
            } else if (this.deviceType === 'channel' && item.name === 'RtilChannelPGM') {
              this.videoInputArray.push(item.name);
              this.audioInputChannel[item.name] = item.audioChannelCount / 2;
            }
            if (item.name === sourceType) {
              if (this.deviceType === 'producer' && sourceType === 'PGM') {
                this.selectVideoInput = 'PGM (mix minus)';
              } else if (this.deviceType === 'producer') {
                this.selectVideoInput = this.pgmNameInfo[item.name];
              } else {
                this.selectVideoInput = item.name;
              }
            } else if (originMemberId.includes('voip')) {
              this.selectVideoInput = 'noVideo';
              this.selectAudioInput = 'voip';
            } else if (this.deviceType === 'producer' && sourceType === 'StudioOutput') {
              this.selectVideoInput = 'PGM';
            }
          });
          if (this.deviceType === 'receiver') {
            this.videoInputArray.push('noVideo');
            this.audioInputChannel.noVideo = 4;
          }
          if (this.deviceType === 'producer') {
            this.videoInputArray = this.videoInputArray.sort((item1, item2) => {
              if (Number(item1.slice(1)) < Number(item2.slice(1))) {
                return -1;
              } else if (Number(item1.slice(1)) == Number(item2.slice(1))) {
                return 0;
              } else {
                return 1;
              }
            });
            this.videoInputArray.unshift('PGM');
            this.videoInputArray.unshift('PGM (mix minus)');
          }
        }
      });
    },
    getEncoderInfo() {
      const {
        info,
        channel,
        id
      } = this.detail;
      const {
        devicePeerId
      } = info;
      this.axios.get(`/partyline-backend/receiver/encoder?rid=${devicePeerId}`).then(res => {
        if (res.data.errorCode === '0x0') {
          if (!res) return;
          // 只需要当前会议的 encoder 信息
          const result = res.data.result;
          if (result && result.length) {
            const encoderInfo = result.filter(item => {
              return item.realPartyCode == channel;
            });
            encoderInfo.forEach(item => {
              if (item.partyEncoder.UserId == id) {
                this.selectAudioInput = item.partyEncoder.Audio.Tracks[0] || 1;
              }
            });
          } else {
            this.selectAudioChannel = 1;
          }
        }
      }).catch(e => {
        console.log(e);
      });
    },
    returnDetailName(key) {
      switch (key) {
        case 'name':
          if (this.deviceType === 'producer' || this.deviceType === 'channel') {
            return this.$t('detail.programName');
          } else {
            return this.$t('detail.deviceName');
          }
        case 'type':
          return this.$t('detail.deviceType');
        case 'pid':
          return this.$t('detail.devicePid');
        case 'version':
          return this.$t('detail.deviceVersion');
      }
    },
    returnSourceType(info) {
      const {
        devicePeerId
      } = info;
      switch (info.deviceType) {
        case 'T':
          return 'pack';
        case 'R':
          if (devicePeerId.includes('fffffffbb')) {
            return 'producer';
          } else if (devicePeerId.includes('fffffffcc')) {
            return 'cloudR';
          } else if (devicePeerId.includes('fffffff11')) {
            return 'channel';
          } else {
            return 'receiver';
          }
      }
    },
    returnPartyID(peerId) {
      return this.$options.filters.returnStrByInfo(peerId, 4);
    },
    returnLabel(name) {
      let _str = '';
      if (this.deviceType === 'producer') {
        if (name !== 'PGM (mix minus)' && name !== 'PGM' && name) {
          _str = name.replace('s', 'Slot');
        } else {
          _str = name;
        }
      } else if (this.deviceType === 'channel') {
        if (name === 'RtilChannelPGM') {
          _str = 'Channel Output';
        } else {
          _str = name;
        }
      } else {
        if (name === 'SDIIN') {
          _str = 'SDI IN/HDMI IN';
        } else if (name === 'noVideo') {
          _str = 'No Video';
        } else {
          _str = name == 'Default' ? 'Live Source' : name;
        }
      }
      return _str;
    },
    returnVideoDisabled(videoType) {
      const {
        info
      } = this.detail;
      const {
        originMemberId
      } = info;
      if (this.deviceType === 'pack') {
        if (originMemberId.includes('voip')) {
          return videoType != 'noVideo';
        } else {
          return videoType == 'noVideo';
        }
      } else if (this.deviceType === 'receiver') {
        if (originMemberId.includes('Default')) {
          return videoType != 'Default';
        } else if (originMemberId.includes('voip')) {
          return videoType != 'noVideo';
        } else {
          const sourceType = originMemberId.slice(originMemberId.indexOf('_') + 1);
          return videoType != sourceType;
        }
      }
    },
    audioRadioDisabled(type) {
      if (this.deviceType === 'pack') {
        if (this.selectVideoInput === 'SDIIN') {
          return type === 'voip' || type === 'noAudio';
        } else {
          return type !== 'voip';
        }
      } else if (this.deviceType === 'receiver') {
        if (this.selectVideoInput === 'noVideo') {
          return type !== 'voip';
        } else {
          return type === 'voip' || type === 'noAudio';
        }
      }
    },
    returnAudioInput(item) {
      if (this.deviceType === 'pack') {
        return 'SDI IN/HDMI IN';
      } else {
        return this.$t('audioChannels.stereo') + ' ' + item;
      }
    },
    dealDefaultValue(val) {
      if (this.deviceType === 'pack') {
        if (val === 'SDIIN') {
          this.selectAudioInput = 1;
        } else {
          this.selectAudioInput = 'voip';
        }
      } else if (this.deviceType === 'receiver') {
        if (val === 'noVideo') {
          this.selectAudioInput = 'voip';
        } else {
          this.selectAudioInput = 1;
        }
      }
    }
  }
};